<script setup lang="ts">
import settingService from '@/services/ide/settings/setting.service'
import { useIdeStore } from '@/stores/ide.store'

const props = defineProps({
  title: {
    type: String,
    required: false
  }
})

/**
 * Sets settingstore value to close popup
 */
function handleCloseIdeModal() {
  settingService.closePopup()
  if (window.innerWidth < 640) {
    useIdeStore().setSideBarCollapsed(true)
  }
}
</script>

<template>
  <div class="absolute -left-0.5 -top-14 z-50">
    <!-- Modal body -->
    <div
      class="section-quaternary border-primary relative grow rounded-r-md rounded-bl rounded-tl-md border px-2 py-2 sm:px-4"
    >
      <h1 v-if="props.title" class="mb-5 text-center text-sm font-semibold">
        {{ props.title }}
      </h1>
      <button class="absolute right-0 top-0 px-2 py-1">
        <FontAwesomeIcon icon="fa-close" class="text-md" @click="handleCloseIdeModal" />
      </button>
      <!-- main content -->
      <slot />
    </div>

    <!-- Modal Horn -->
    <!-- Inline styling solves mysterious bug, where dark mode ignores the transparent classes -->
    <div
      class="border-primary border-t-primary relative left-1 z-50 h-0 w-0 border-l-[10px] border-r-[10px] border-t-[10px] !border-l-transparent !border-r-transparent"
    >
      <div
        class="border-quaternary border-t-primary relative -left-[9.5px] -top-[11.5px] z-50 h-0 w-0 border-l-[10px] border-r-[10px] border-t-[10px] !border-l-transparent !border-r-transparent"
      ></div>
    </div>
  </div>
</template>
